/**
 * Share content using Web Share API or fallback to clipboard
 * @param {Object} options Share options
 * @param {string} options.title Title of the content to share
 * @param {string} options.text Text description
 * @param {string} [options.url] Optional URL to share
 * @returns {Promise<{success: boolean, method: string}>}
 */
export async function shareContent({ title, text, url }) {
  // Use current page URL if none provided
  const shareUrl = url || window.location.href;

  // Try Web Share API first (mobile/modern browsers)
  if (navigator.share) {
    try {
      await navigator.share({
        title,
        text,
        url: shareUrl,
      });
      return { success: true, method: 'native' };
    } catch (error) {
      // User cancelled or share failed
      if (error.name === 'AbortError') {
        return { success: false, method: 'cancelled' };
      }
      console.warn('Web Share API failed, falling back to clipboard:', error);
    }
  }

  // Fallback to clipboard
  try {
    const shareText = `${title}\n${text}\n${shareUrl}`;
    await navigator.clipboard.writeText(shareText);
    return { success: true, method: 'clipboard' };
  } catch (error) {
    console.error('Clipboard fallback failed:', error);
    return { success: false, method: 'failed' };
  }
}
